import React from 'react'
import { useContext } from 'react'
import './itemDescription.scss'

import Cards from '../Cards/Cards'

import { DBContext } from '../../contexts/databases'

import itemInfo from '../../data/Items/itemInfo.json'
import idnum2itemresnametable from '../../data/Items/idnum2itemresnametable.json'
import num2cardillustnametable from '../../data/Items/num2cardillustnametable.json'

function ItemDescription(props) {
	// const { lastSelectedItem, item_db_equip } = useContext(EquipmentContext)
	const { /*lastSelectedItem,*/ item_db_equip } = useContext(DBContext)
	// const { lastSelectedItem, item_db_equip } = useContext(DBContext)

	const lastSelectedItem = props.lastSelectedItem

	let regex = new RegExp('\\^([0-f][0-f][0-f][0-f][0-f][0-f])')
	let itemDesc = []
	//navigation dans les paires clé/valeur de l'objet
	//ici identifiedDescriptionName
	if (itemInfo[lastSelectedItem.toString()])
		for (const [key, value] of Object.entries(
			itemInfo[lastSelectedItem.toString()]?.identifiedDescriptionName,
		)) {
			let newString = value.replace('^000000', '</span>')
			//in case of two color in the  same line
			newString = newString.replace('^000000', '</span>')
			if (regex.exec(value))
				newString = newString.replace(
					regex.exec(value)[0],
					'<span style="color: #' + regex.exec(value)[1] + '">',
				)

			if (regex.exec(value))
				newString = newString.replace(
					regex.exec(value)[0],
					'<span style="color: #' + regex.exec(value)[1] + '">',
				)
			itemDesc[key] = newString
		}
	return (
		<div className='itemDescription'>
			<Cards Name={'Item description'}>
				<div className='title'>
					<img
						src={
							'https://images.roprime-simulator.com/item/' +
							//Some items are in idnum2itemresnametable.txt but not all of them
							//if not in idnum2itemresnametable.txt, check iteminfo.lua
							(idnum2itemresnametable[lastSelectedItem] !==
							undefined
								? idnum2itemresnametable[
										lastSelectedItem
									].toLowerCase()
								: itemInfo[
										lastSelectedItem
									]?.identifiedResourceName.toLowerCase()) +
							'.bmp'
						}
						alt=''
					/>
					<h2>
						{itemInfo[lastSelectedItem]?.identifiedDisplayName !==
						' '
							? itemInfo[lastSelectedItem]?.identifiedDisplayName
							: 'Unknown'}
						{itemInfo[lastSelectedItem]?.slotCount > 0
							? ' [' + itemInfo[lastSelectedItem]?.slotCount + ']'
							: null}
					</h2>
				</div>
				<div className='body'>
					<img
						src={
							num2cardillustnametable[lastSelectedItem] ===
								undefined ||
							num2cardillustnametable[lastSelectedItem] === '0'
								? 'https://images.roprime-simulator.com/collection/' +
									(idnum2itemresnametable[
										lastSelectedItem
									] !== undefined
										? idnum2itemresnametable[
												lastSelectedItem
											].toLowerCase()
										: itemInfo[
												lastSelectedItem
											]?.identifiedResourceName.toLowerCase()) +
									'.bmp'
								: 'https://images.roprime-simulator.com/cardbmp/' +
									(num2cardillustnametable[
										lastSelectedItem
									] !== undefined
										? num2cardillustnametable[
												lastSelectedItem
											].toLowerCase()
										: itemInfo[
												lastSelectedItem
											]?.identifiedResourceName.toLowerCase()) +
									'.bmp'
						}
						className='itemImage'
						alt=''
					/>
					<div className='desc'>
						{itemDesc.map((descLine, index) => (
							<div
								dangerouslySetInnerHTML={{ __html: descLine }}
								key={index}
							/>
						))}
						{item_db_equip.find(
							(item) => item.Id === lastSelectedItem,
						)?.Script ? (
							<div>
								<br />
								<div>Script :</div>
								<div>
									{
										item_db_equip.find(
											(item) =>
												item.Id === lastSelectedItem,
										).Script
									}
								</div>
							</div>
						) : null}
					</div>
				</div>
			</Cards>
		</div>
	)
}

export default ItemDescription
